import { CONSENT_CHANGED_EVENT } from '../../consent/changeEvents'
import { useEffect, useRef } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { rebucketExperiments } from 'actions/ExperimentActions'
import { trackClientEvent } from 'analytics/analytics'
import { EXPERIMENT_PREVIEW_CONTEXT_EVENT, isExperimentPreview } from 'lib/experiments/preview'

function reportPreviewContext() {
  trackClientEvent(EXPERIMENT_PREVIEW_CONTEXT_EVENT)
}

/** Report preview visits independently of enrolment and restore eligibility when leaving preview. */
function ExperimentPreviewContext() {
  const dispatch = useAppDispatch()
  const previewMode = useAppSelector(isExperimentPreview)
  const wasPreview = useRef(previewMode)
  const location = useAppSelector(state => state.router.location)
  const memberId = useAppSelector(state => state.auth.account.memberId)
  const resolvedTrackingId = useAppSelector(state => state.auth.resolvedTrackingId)

  useEffect(() => {
    if (!previewMode) return
    reportPreviewContext()
    window.addEventListener(CONSENT_CHANGED_EVENT, reportPreviewContext)
    return () => window.removeEventListener(CONSENT_CHANGED_EVENT, reportPreviewContext)
  }, [location, memberId, previewMode, resolvedTrackingId])

  useEffect(() => {
    if (wasPreview.current && !previewMode) {
      dispatch(rebucketExperiments())
    }
    wasPreview.current = previewMode
  }, [dispatch, previewMode])

  return null
}

export default ExperimentPreviewContext
